<template>
  <div>
    <v-row class="px-3">
      <v-col cols="12" class="grey lighten-4 round-corners">
        <v-row align="center" no-gutters>
          <v-col cols="8" class="font-weight-bold" v-html="title"></v-col>
          <v-col cols="4" class="text-right">
            <v-btn small color="primary" @click="show()" v-if="isEditing">Añadir</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <!-- Table -->
      <v-col cols="12">
        <v-data-table
          :headers="filteredHeaders"
          :items="items"
          class="elevation-0"
          :items-per-page="5"
        >
          <!-- Actions -->
          <template v-slot:item.action="{ item }">
            <v-icon class="mr-2" @click="show('edit', item)">mdi-pencil</v-icon>
            <v-icon @click="show('delete', item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      width="500px"
    >
      <v-card v-if="dialog">
        <v-card-title primary-title>
          {{ text }} {{ titleDialog }}
        </v-card-title>
        <v-card-text>
          <v-row justify="space-around">
            <!-- Options -->
            <v-col cols="9">
              <v-autocomplete
                v-model="item.option"
                :error-messages="optionErrors"
                :items="options"
                :label="labelOptions"
                item-text="name"
                item-value="id"
                :hint="hint"
                :persistent-hint="persistentHint"
              ></v-autocomplete>
            </v-col>
            <!-- Quantity -->
            <v-col cols="3">
              <v-text-field
                v-model="item.quantity"
                :error-messages="quantityErrors"
                :label="labelQuantity"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <v-btn text class="mr-4" @click="close()">Cancelar</v-btn>
          <v-btn color="primary" class="white--text" :disabled="invalid" @click="save()" v-text="text"></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Confirmation -->
    <confirmation
      v-model="deleteDialog"
      :title="`Eliminar ${titleDialog}`"
      :text="`Desea eliminar el ${titleDialog}`"
      :item="item[option]"
      @close="close('delete')"
      @confirm="deleteItem()"
    />
  </div>
</template>

<script>
import Confirmation from "@/components/Confirmation";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    Confirmation
  },
  props: {
    isEditing: Boolean,
    persistentHint: Boolean,
    items: Array,
    headers: Array,
    options: Array,
    option: String,
    title: String,
    titleDialog: String,
    labelOptions: String,
    labelQuantity: { type: String, default: 'Cantidad' },
    hint: String
  },
  mixins: [validationMixin],
  validations: {
    item: {
      option: { required },
      quantity: { required },
    },
  },
  data: () => ({
    dialog: false,
    deleteDialog: false,
    item: {}
  }),
  watch: {
    dialog (val) {
      val || this.close()
    },
    confirmDialog (val) {
      val || this.close()
    },
  },
  computed: {
    isNew () {
      return !this.item.id
    },
    text () {
      return this.isNew ? 'Añadir' : 'Modificar'
    },
    invalid () {
      return this.$v.$invalid && this.$v.$dirty
    },
    filteredHeaders () {
      return this.headers.filter(element => this.isEditing && element.value === 'action' || element.value !== 'action')
    },
    optionErrors () {
      const errors = []
      if (!this.$v.item.option.$dirty) return errors
      !this.$v.item.option.required && errors.push('Obligatorio.')
      return errors
    },
    quantityErrors () {
      const errors = []
      if (!this.$v.item.quantity.$dirty) return errors
      !this.$v.item.quantity.required && errors.push('Obligatorio.')
      return errors
    },
  },
  methods: {
    show (dialog, item) {
      console.log("show -> item", item)
      if (item) this.item = item
      dialog === 'delete'
        ? this.deleteDialog = true
        : this.dialog = true
    },
    close (dialog) {
      if (dialog === 'delete') this.deleteDialog = false
      else {
        this.dialog = false
        this.$emit('close')
      }
      this.item = {}
      this.$v.$reset()
    },
    deleteItem () {
      this.$emit('delete', this.item)
      this.close('delete')
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('save', this.item)
        this.close()
      }
    },
  }
}
</script>
